import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'


const initialState = {
  user: {},
  eventId: "",
  namePharmacy: "",
  eventHash: "",
  urlDownloadDocument: "",
  urlDownloadAutocertificazione: "",
  urlDownloadReport: '',
  tagManagerBackoffice: null,
  rangEvent: {},
  saml: false,
}

const loginReducer = createSlice({
  name: 'login',
  initialState,
  reducers: {
    deleteUser(state) {
      state.user = {};
    },
    deleteEvent(state) {
      state.eventId = "";
    },
    deleteNamePharmacy(state) {
      state.namePharmacy = "";
    },
    deleteRangEvent(state) {
      state.rangEvent = {};
    },
    updateUser(state, action: PayloadAction<any>) {
      state.user = action.payload;
    },
    updateEventHash(state, action: PayloadAction<any>) {
      state.eventHash = action.payload;
    },
    updateRangEvent(state, action: PayloadAction<any>) {
      state.rangEvent = action.payload;
    },
    updateEventId(state, action: PayloadAction<any>) {
      state.eventId = action.payload;
    },
    updateUrlDownloadDocument(state, action: PayloadAction<any>) {
      state.urlDownloadDocument = action.payload;
    },
    updateUrlAutocertificazione(state, action: PayloadAction<any>) {
      state.urlDownloadAutocertificazione = action.payload;
    },
    updateUrlReport(state, action: PayloadAction<any>) {
      state.urlDownloadReport = action.payload;
    },
    updateNamePharmacy(state, action: PayloadAction<any>) {
      state.namePharmacy = action.payload;
    },
    updateTagManagerBackoffice(state, action: PayloadAction<any>) {
      state.tagManagerBackoffice = action.payload;
    },
    updateSaml(state, action: PayloadAction<boolean>) {
      state.saml = action.payload;
    }
  },
})

export const {
  deleteUser,
  updateUser,
  deleteEvent,
  updateEventId,
  updateNamePharmacy,
  updateEventHash,
  deleteNamePharmacy,
  updateTagManagerBackoffice,
  updateSaml,
  deleteRangEvent,
  updateRangEvent,
  updateUrlDownloadDocument,
  updateUrlAutocertificazione,
  updateUrlReport
} = loginReducer.actions

export default loginReducer.reducer

